import { useEffect, useState } from 'react';
import { fetchWithAuth } from '../../utils/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Tiny hook — fetches the counts of institutions we can already read files
// from AND ones we recognise but haven't finished the reader for, for the
// current User's country. Used by the "Import from your institution" modal
// to display an honest progress line.
//
// Fails silently: if the fetch ever hiccups, the modal simply omits the line.
export function useSupportedInstitutionCount() {
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchWithAuth(`${BACKEND_URL}/api/institution-import/supported`);
        if (!res.ok) return;
        const body = await res.json();
        const list = Array.isArray(body?.institutions) ? body.institutions : [];
        // Exclude the "*" global-template placeholder from the per-country
        // counter so the User sees "10 in your country", not "11".
        const country_list = list.filter((i) => i.country_code !== '*');
        const readable = country_list.filter((i) => i.readable !== false).length;
        const recognised = country_list.filter((i) => i.readable === false).length;
        if (!cancelled) setCounts({
          readable,
          recognised,
          total: list.length,
          // Global counters — used to lead the modal copy with the stronger
          // "N across M countries" signal instead of the per-country number.
          globalReadable: body?.global_readable ?? readable,
          globalTotal: body?.global_total ?? list.length,
          globalCountries: body?.global_countries ?? 0,
          // Full institution list + user's country ISO — used by the
          // country-filter dropdown to let the User browse any market.
          allInstitutions: Array.isArray(body?.all_institutions) ? body.all_institutions : [],
          userCountryIso: body?.user_country_iso || '',
        });
      } catch {
        // Silent — the modal just won't show the counter line.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return counts;
}
